import React, { useState } from "react";
import { CheckIfUserExists } from "./CheckIfUserExists";
import Login from "./Login";
import Register from "./Register";
export const LoginOrRegister = ({ codeInfo, handleGoBack, handleLoginSuccess, }) => {
    const [state, setState] = useState("validate-email");
    const [email, setEmail] = useState("");
    switch (state) {
        case "validate-email":
            return (React.createElement(CheckIfUserExists, { codeInfo: codeInfo, handleUserExists: () => setState("login"), handleUserNotExists: () => setState("register"), handleGoBack: handleGoBack, email: email, onSetEmail: setEmail }));
        case "login":
            return (React.createElement(Login, { email: email, handleGoBack: () => setState("validate-email"), handleLoginSuccess: handleLoginSuccess }));
        case "register":
            return (React.createElement(Register, { subjectInfo: codeInfo, handleGoBack: () => setState("validate-email"), email: email, onLoggedIn: handleLoginSuccess }));
    }
};
